export default "__VITE_ASSET__DQnS1ix___"